import { render, staticRenderFns } from "./SimplifiedEditingTable.vue?vue&type=template&id=20bbb84e&scoped=true&lang=pug"
import script from "./SimplifiedEditingTable.vue?vue&type=script&lang=js"
export * from "./SimplifiedEditingTable.vue?vue&type=script&lang=js"
import style0 from "./SimplifiedEditingTable.vue?vue&type=style&index=0&id=20bbb84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbb84e",
  null
  
)

export default component.exports